import { BrowserAuthorizationClient } from "@itwin/browser-authorization";
import { IModelConnection } from "@itwin/core-frontend";
import { Viewer, ViewerViewportControlOptions } from "@itwin/web-viewer-react";
import { /* placeGltfAsset, */ setIModel } from "../GLTF/GLTF";
import { mapLayerOptions, tileAdminOptions } from "../Maps/MapSettings";
import { MarkerPinWidgetProvider } from "../MarkerPin/MarkerPinWidget";
import { GlobalDisplayWidgetProvider } from "../Widgets/MapWidget";
import ViewApi from "../Widgets/ViewApi";
import { RenderWidgetProvider } from "../Widgets/RenderWidget";

export interface SurplusMapViewerProps {
  iTwinId: string;
  iModelId: string;
  authClient: BrowserAuthorizationClient;
}

export const SurplusmapViewer: React.FC<SurplusMapViewerProps> = (props) => {
  const { iTwinId, iModelId, authClient } = props;
  const uiProviders = [
    new MarkerPinWidgetProvider(),
    new RenderWidgetProvider(),
    new GlobalDisplayWidgetProvider(),
  ];
  const viewportOptions: ViewerViewportControlOptions = {
    viewState: async (iModelConnection) => ViewApi.getIsoView(iModelConnection),
  };

  const onIModelConnected = async (iModel: IModelConnection) => {
    setIModel(iModel);
  };

  return (
    <Viewer
      iTwinId={iTwinId ?? ""}
      iModelId={iModelId ?? ""}
      authClient={authClient}
      enablePerformanceMonitors={false} // see description in the README (https://www.npmjs.com/package/@itwin/web-viewer-react)
      viewportOptions={viewportOptions}
      uiProviders={uiProviders}
      mapLayerOptions={mapLayerOptions}
      onIModelConnected={onIModelConnected}
      tileAdmin={tileAdminOptions}
      theme="dark"
    />
  );
};
